import config from '../constants/config';
import { BigNumber } from 'ethers';
import { useContractRead } from 'wagmi';
import { useState } from 'react';

export type AmountsPerTokenId = Record<number, BigNumber>;

const useClaimedHoneyForBearsToHive = (
  tokenIds?: number[]
): [amountsPerBear: AmountsPerTokenId | undefined, read: () => void] => {
  const [amountsPerBear, setAmountsPerBear] = useState<AmountsPerTokenId>();

  const { refetch } = useContractRead({
    addressOrName: config.contracts.fancyBearStakingRewardContractV2.address,
    contractInterface:
      config.contracts.fancyBearStakingRewardContractV2.interface,
    functionName: 'getClaimedHoneyForBearsToHive',
    args: [tokenIds],
    onSettled: (data, error) => {
      if (error || !data || !tokenIds) {
        setAmountsPerBear({});
      } else {
        setAmountsPerBear(
          tokenIds.reduce(
            (prev, tokenId, index) => ({
              ...prev,
              [tokenId]: data[index] as any as BigNumber,
            }),
            {}
          )
        );
      }
    },
  });

  return [tokenIds?.length ? amountsPerBear : {}, refetch];
};

export default useClaimedHoneyForBearsToHive;
